import { DRCValuationAPIResource } from "../drc-valuation.service";
import { depreciation, getDepreciationOptions } from "./calculation/calculation";
import { mapLevel } from "./level";

export function drcSummary(
  data: DRCValuationAPIResource,
  currency: string
) {
  const converted = {
    landInput: {
      size: data.land_size,
      price: data.land_price,
      description: data.land_description,
      unit: null
    },
    modelAssumption: {
      constructionCostId: data.model_construction_cost_id,
      isEscalationAndFinancingAdded: data.model_is_escalation_financing_added,
      levelId: data.model_level
    },
    valuationDate: data.valuation_date ? new Date(data.valuation_date) : null,
    projects: data.projects.map(item => {
      return {
        id: item.id,
        index: item.index,
        buildingConstructionDate: item.building_construction_date ? new Date(item.building_construction_date) : null,
        projectName: item.name,
        propertyConstructionCostId: item.property_construction_cost_id,
        size: item.size,
        useLandValueInput: item.use_land_value_input,
        useSizeAsQuantity: item.use_size_as_quantity,
        usePropertyCostTemplate: item.use_property_cost_template,
        records: item.rows,
        depreciationMethod: item.depreciation_method_id,
        depreciationLevel: item.depreciation_level_id,
        sCurveSteepness: item.s_curve_steepness,
        economicLife: item.economic_life,
        salvageValue: item.salvage_value,
        depreciationFactorPerYear: item.depreciation_factor_per_year
      }
    }),
  }

  let usedLandInput = false
  const calculatedProjects = converted.projects.map(item => {
    if (item.useLandValueInput) {
      usedLandInput = true
    }
    const options = getDepreciationOptions(
      item.depreciationMethod,
      item.sCurveSteepness,
      item.economicLife,
      item.salvageValue,
      item.depreciationFactorPerYear,
      item.depreciationLevel,
      'Summary'
    )
    const result = depreciation(
      item.records,
      {
        valuationDate: converted.valuationDate,
        landInput: converted.landInput,
        buildingConstructionDate: item.buildingConstructionDate,
        useLandValueInput: item.useLandValueInput,
        useSizeAsQuantity: item.useSizeAsQuantity,
        size: item.size,
        level: converted.modelAssumption.levelId
      },
      options
    )
    if (!result) return null
    const { records, totalCost: cost, totalDepreciatedCost: depreciated_cost } = result
    return {
      index: item.index,
      records: records.map(item => {
        if (item.kind === 'header') return item;
        return {
          ...item,
          unit_selected: _selectedUnit(item.unit)
        }
      }),
      total: {
        cost,
        depreciated_cost,
        depreciated_per_unit: depreciated_cost / item.size
      }
    }
  })

  const landInputTotal = converted.landInput ? converted.landInput.size * converted.landInput.price : 0
  const total = calculatedProjects
    .filter(item => item !== null)
    .reduce((acc, item) => {
      return acc + item.total.cost
    }, usedLandInput ? landInputTotal : 0)

  return {
    result: {
      currency,
      level: mapLevel(converted.modelAssumption.levelId),
      projects: calculatedProjects,
      usedLandInput,
      landInputTotal: landInputTotal,
      total
    },
    level: converted.modelAssumption.levelId,
    valuationDate: converted.valuationDate,
    landInput: converted.landInput,
    currency,
    projects: converted.projects
  }
}

function _selectedUnit(unit: number) {
  const item = _options.find(x => x.value === unit)
  return item ? item.label : 'N/A'
}

const _options = [
  {value: 1, label: '-'},
  {value: 2, label: '/ Sq. m.'},
  {value: 4, label: '/ Piece'},
  {value: 5, label: '/ Set'},
  {value: 6, label: '/ m'},
  {value: 7, label: '/ m3'},
  {value: 8, label: '/ Tonne'},
  {value: 9, label: '%'},
  {value: 10, label: '/ Floor'},
  {value: 11, label: '/ Room'},
  {value: 12, label: '/ Unit'},
  {value: 13, label: '% Of Total Construction Costs, excluding groups 08, 10'},
  {value: 14, label: '% Of Total Construction Costs, excluding groups 08, 09, 10'},
  {value: 15, label: '% Of Total Construction Costs, excluding groups 09, 10'},
  {value: 16, label: '% Of Total Construction Costs, excluding groups 13'},
  {value: 17, label: '% Of Site acquisition costs'},
]